import { Component, OnInit, Input } from '@angular/core';
import { Session } from 'src/app/models/session';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-agregar-repuesto-dialog',
  templateUrl: './agregar-repuesto-dialog.component.html',
  styleUrls: ['./agregar-repuesto-dialog.component.css']
})
export class AgregarRepuestoDialogComponent implements OnInit {

  constructor(private session: Session, private service: UserService,private activeModal: NgbActiveModal) { }

  @Input()
  fijos = [];
  
  repuestos = [];

  productos = [];
  selectedProducto;
  selectedRepuesto;
  selectedCantidad = 1;

  nuevos = [];
  ngOnInit() {
    console.log(this.fijos);
    
    if(this.session.repuestos.length<1){
      this.service.getProductos().subscribe(d=>{
        this.session.productos = d.productos;
        this.productos = d.productos;
      })
    }
    else this.productos = this.session.productos;

  }

  flash = -1;
  agregar(){
    this.flash = -1;
    if(this.selectedCantidad<1) return;
    let index = this.nuevos.findIndex(x=> x._id == this.selectedRepuesto._id);
    if(index >=0){
      return this.flash = index;
    }
    let repuesto = this.selectedRepuesto;
    let cantidad = this.selectedCantidad;
    let add = { cantidad: cantidad, _id: repuesto._id, nombre: repuesto.nombre, producto: this.selectedProducto};
    console.log(JSON.stringify(this.selectedRepuesto));
    console.log(add);
    
    this.nuevos.push(add);
  }


  remove(i){
    this.nuevos.splice(i,1);
  }


  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {
    this.activeModal.close(this.nuevos);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  getRepuestos(){
    this.service.getProductRepuestos(this.selectedProducto.codigo).subscribe(d=>{
      this.repuestos = d.repuestos.map( x=> { return { nombre: x.nombre, _id: x.codigo}});
      this.repuestos.sort(function(a,b){ return a.nombre > b.nombre? 1:-1});
    })
  }
}
